
(function() {
  if (!window.location.pathname.includes('/products/')) return;

  function run() {
    var desc = document.querySelector('.product__description');
    if (!desc) return;

    var html = desc.innerHTML;
    if (!html || html.trim().length < 20) return;

    // Build tab map from accordion blocks
    var tabMap = {};
    var accordions = document.querySelectorAll('.product__accordion');
    accordions.forEach(function(acc) {
      var titleEl = acc.querySelector('.accordion__title');
      if (!titleEl) return;
      var heading = titleEl.textContent.trim().toLowerCase();
      var contentDiv = acc.querySelector('.accordion__content');
      if (contentDiv) tabMap[heading] = { el: contentDiv, accordion: acc };
    });

    // Parse description HTML for sections
    var temp = document.createElement('div');
    temp.innerHTML = html;

    var sections = {};
    // Order matters: 'active ingredients' before 'ingredients' to match correctly
    var sectionDefs = [
      { names: ['benefits'], key: 'benefits' },
      { names: ['active ingredients', 'key ingredients'], key: 'active ingredients' },
      { names: ['ingredients', 'ingredients (inci)', 'inci'], key: 'ingredients (inci)' },
      { names: ['how to use', 'directions'], key: 'how to use' },
      { names: ['expert tip'], key: 'expert tip' }
    ];

    var introNodes = [];
    var currentSection = null;

    function matchSection(text) {
      text = text.toLowerCase().replace(/:$/, '').trim();
      for (var i = 0; i < sectionDefs.length; i++) {
        for (var j = 0; j < sectionDefs[i].names.length; j++) {
          if (text === sectionDefs[i].names[j]) return sectionDefs[i].key;
        }
      }
      return null;
    }

    var children = Array.from(temp.childNodes);
    children.forEach(function(node) {
      if (node.nodeType === 1) {
        var text = node.textContent.trim();
        var matched = matchSection(text);
        
        if (matched && text.length < 50) {
          var isHeading = /^H[2-4]$/.test(node.tagName);
          var isStrongLike = (node.tagName === 'P' || node.tagName === 'STRONG' || node.tagName === 'B') && text.length < 40;
          if (isHeading || isStrongLike) {
            currentSection = matched;
            if (!sections[currentSection]) sections[currentSection] = [];
            return;
          }
        }
        // Check for strong/b inside p
        if (node.tagName === 'P' && node.children.length > 0) {
          var firstChild = node.children[0];
          if (firstChild && (firstChild.tagName === 'STRONG' || firstChild.tagName === 'B')) {
            var innerText = firstChild.textContent.trim();
            var matchedInner = matchSection(innerText);
            if (matchedInner && innerText.length < 40) {
              currentSection = matchedInner;
              if (!sections[currentSection]) sections[currentSection] = [];
              var remaining = node.innerHTML.replace(firstChild.outerHTML, '').trim();
              if (remaining) sections[currentSection].push('<p>' + remaining + '</p>');
              return;
            }
          }
        }
      }
      if (currentSection) {
        if (!sections[currentSection]) sections[currentSection] = [];
        if (node.nodeType === 1) sections[currentSection].push(node.outerHTML);
        else if (node.nodeType === 3 && node.textContent.trim()) sections[currentSection].push(node.textContent);
      } else {
        if (node.nodeType === 1) introNodes.push(node.outerHTML);
        else if (node.nodeType === 3 && node.textContent.trim()) introNodes.push(node.textContent);
      }
    });

    var filled = 0;
    // Fill accordion tabs with extracted content
    Object.keys(tabMap).forEach(function(tabName) {
      var content = sections[tabName];
      if (content && content.length > 0) {
        tabMap[tabName].el.innerHTML = content.join('');
        filled++;
      }
    });

    // If we extracted content, clean description to intro only
    if (filled > 0 && introNodes.length > 0) {
      desc.innerHTML = introNodes.join('');
    }

    // Hide empty tabs (no content extracted)
    Object.keys(tabMap).forEach(function(tabName) {
      if (!sections[tabName] || sections[tabName].length === 0) {
        tabMap[tabName].accordion.style.display = 'none';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(run, 100); });
  } else {
    setTimeout(run, 100);
  }
})();
